import { render, staticRenderFns } from "./mutil-upload.vue?vue&type=template&id=352f3a13&scoped=true&"
import script from "./mutil-upload.vue?vue&type=script&lang=js&"
export * from "./mutil-upload.vue?vue&type=script&lang=js&"
import style0 from "./mutil-upload.vue?vue&type=style&index=0&id=352f3a13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352f3a13",
  null
  
)

export default component.exports